export default __webpack_public_path__ + "static/media/z050ma0b.a8b80809.mp3";